import React from "react";
import { Button, Form, Icon, Input } from "antd";
import ReactToPrint from "react-to-print";

const OfferNumber = ({
  form,
  disabled,
  componentRef,
  handleClickShowAllFields
}) => {
  const { getFieldDecorator } = form;
  return (
    <div className="offer-card__item">
      <span className="label">Номер предложения:</span>
      <Form.Item>
        {getFieldDecorator("offerNumber")(
          <Input style={{ width: 368 }} disabled={disabled} />
        )}
      </Form.Item>
      <Form.Item hidden={true}>
        {getFieldDecorator("offerId")(
          <Input style={{ width: 368 }} disabled={disabled} />
        )}
      </Form.Item>
      <span className="extra-label">
        <span className="show-map">
          <ReactToPrint
            content={() => componentRef}
            bodyClass={"offer-card__form"}
            onBeforeGetContent={() => {
              handleClickShowAllFields(true);
            }}
            trigger={() => {
              return (
                <Button
                  type="link"
                  className="print-order"
                  id="print-order-btn"
                >
                  Распечатать заказ <Icon type="printer" />
                </Button>
              );
            }}
          />
        </span>
      </span>
    </div>
  );
};
export default OfferNumber;
